import { CountryISO } from '@/types/places';
import { User } from '@/types/user';

import { getOtherTaxCountries, shouldShowTinForCountry } from '@/utils/user';

type GetSSNTINConfigProps = {
  differentTaxResidency: boolean;
  taxResidences: string[];
  isGuyanaUser: boolean;
  country: string;
  requiredLocalTIN: boolean;
  user?: User;
  localISO: string;
};

export const getSSNTINConfig = ({
  differentTaxResidency,
  taxResidences,
  isGuyanaUser,
  country,
  requiredLocalTIN,
  user,
  localISO,
}: GetSSNTINConfigProps) => {
  let selectedTaxCountries: string[] = [];
  if (differentTaxResidency) {
    selectedTaxCountries = taxResidences.filter(Boolean) || [];
  } else {
    selectedTaxCountries = isGuyanaUser ? [] : [country];
  }

  const shouldShowLocalTin =
    requiredLocalTIN &&
    shouldShowTinForCountry(user, selectedTaxCountries, localISO as CountryISO);

  const shouldShowUsTin = shouldShowTinForCountry(
    user,
    selectedTaxCountries,
    CountryISO.US,
  );

  const otherCountriesTin = shouldShowLocalTin
    ? getOtherTaxCountries(selectedTaxCountries, [CountryISO.US, localISO])
    : getOtherTaxCountries(selectedTaxCountries, [CountryISO.US]);

  return {
    shouldShowUsTin,
    shouldShowLocalTin,
    otherCountriesTin,
  };
};
